import React from 'react';
import Banner from 'components/Banner';
import Label from 'components/Label';
import NewsSlider from 'components/NewsSlider';
import TextWithIcon from 'components/TextWithIcon';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchArticle } from 'store/getArticlesSlice';

const Article = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    // @ts-ignore
    const { articles } = useSelector(state => state?.articlesState);

    // @ts-ignore
    const { posts } = useSelector(state => state?.news?.data?.data);
    const sliderPosts = posts.filter(post => post.slug !== slug);

    const currentArticle = articles?.[slug] || {};

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchArticle({
                language: 'en',
                country: 'en',
                slug,
            }),
        );
    }, [dispatch, slug]);

    const { up_text = '', down_text = '', section_text = [], title, title_background, type } = currentArticle;

    console.log('currentArticle', currentArticle);

    const sectionBoxes = section_text
        .map(item => `<div class='box'><img src='${item.image}' alt='article-image' /><div>${item.text}</div></div>`)
        .join('');

    const content = `${up_text || ''}${sectionBoxes}${down_text || ''}`;

    return (
        <>
            <Banner image={title_background} buttonText="LEARN MORE">
                <Label>{type}</Label>
                <h2>{title}</h2>
                <div>
                    <TextWithIcon iconName="calendar" text={'!add date'} />
                    <TextWithIcon iconName="clock" text={'!add time to read'} />
                </div>
            </Banner>

            <article className="article-content" dangerouslySetInnerHTML={{ __html: content }}></article>

            <NewsSlider data={sliderPosts} />
        </>
    );
};

export default Article;
